import React, { useState } from 'react';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';
import { photoUrl } from './betaAdminApi';

export const BetaTestimonialEditor = ({ t, api, reload }) => {
  const bp = t.betaProgram;
  const [text, setText] = useState(bp.testimonialText || '');
  const [notes, setNotes] = useState(bp.notes || '');
  const [reviewUrl, setReviewUrl] = useState(bp.reviewUrl || '');
  const [review, setReview] = useState(!!bp.reviewReceived);
  const [busy, setBusy] = useState('');
  const id = t.practiceId;

  const run = async (key, fn, ok) => {
    setBusy(key);
    try { await fn(); toast.success(ok); await reload(); } catch (e) { toast.error(e.response?.data?.detail || 'Something went wrong'); }
    setBusy('');
  };
  const save = () => run('save', () => api.patch(id, { testimonialText: text, notes, reviewUrl, reviewReceived: review }), 'Saved');

  return (
    <div className="space-y-4 text-sm">
      <div>
        <label className="font-semibold text-slate-900">Testimonial (paste what they sent)</label>
        <Textarea value={text} onChange={(e) => setText(e.target.value)} rows={6} className="mt-1" data-testid={`beta-testimonial-input-${id}`} />
      </div>
      <div className="flex flex-wrap items-center gap-4">
        <div className="w-20 h-20 rounded-full bg-slate-100 overflow-hidden border border-slate-200 shrink-0">
          {t.hasPhoto && <img src={photoUrl(id, bp.photoAt)} alt="" className="w-full h-full object-cover" data-testid={`beta-photo-${id}`} />}
        </div>
        <label className="cursor-pointer text-sky-800 font-semibold hover:underline">
          {busy === 'photo' ? 'Uploading…' : t.hasPhoto ? 'Replace photo' : 'Upload their photo'}
          <input type="file" accept="image/jpeg,image/png,image/webp" className="hidden" data-testid={`beta-photo-input-${id}`}
            onChange={(e) => e.target.files[0] && run('photo', () => api.uploadPhoto(id, e.target.files[0]), 'Photo saved')} />
        </label>
      </div>
      <div className="grid sm:grid-cols-[auto_1fr] gap-3 items-center">
        <label className="flex items-center gap-2 font-semibold text-slate-900">
          <input type="checkbox" checked={review} onChange={(e) => setReview(e.target.checked)} className="h-4 w-4" data-testid={`beta-review-check-${id}`} />
          5-star review received
        </label>
        <Input value={reviewUrl} onChange={(e) => setReviewUrl(e.target.value)} placeholder="Link to the review (optional)" data-testid={`beta-review-url-${id}`} />
      </div>
      <div>
        <label className="font-semibold text-slate-900">Private notes</label>
        <Textarea value={notes} onChange={(e) => setNotes(e.target.value)} rows={3} className="mt-1" data-testid={`beta-notes-input-${id}`} />
      </div>
      <div className="flex flex-wrap gap-2">
        <Button onClick={save} disabled={!!busy} data-testid={`beta-save-btn-${id}`}>{busy === 'save' ? 'Saving…' : 'Save'}</Button>
        <Button variant="outline" disabled={!!busy || !bp.testimonialText} onClick={() => run('pub', () => api.publish(id), 'Published to website testimonials')}
          title={bp.testimonialText ? '' : 'Save their testimonial first'} data-testid={`beta-publish-btn-${id}`}>
          {bp.publishedTestimonialId ? 'Update published testimonial' : 'Publish to website'}
        </Button>
      </div>
    </div>
  );
};
